__webpack_require__.p = "//cnbj1.fds.api.xiaomi.com/vela/prod/";